// export const url = "https://xtratoys.nextechltd.in/api";
export const url = "https://skia.nextechltd.in/api";

// export const url = "http://103.241.144.228:8000/api";

// export const url = "http://localhost:8000/api";
export const isAdmin = false;

export const adminUrl = "https://skia.nextechltd.in/api";
